/**
 * Utility functions for location and map operations
 */

/**
 * Generates a Google Maps URL for a given location
 * @param location - The location string to search for
 * @returns Google Maps search URL
 */
export const generateGoogleMapsUrl = (location: string): string => {
  const encodedLocation = encodeURIComponent(location);
  return `https://www.google.com/maps/search/?api=1&query=${encodedLocation}`;
};

/**
 * Opens Google Maps in a new tab for the given location
 * @param location - The location string to search for
 */
export const openLocationInMaps = (location: string): void => {
  const mapsUrl = generateGoogleMapsUrl(location);
  window.open(mapsUrl, '_blank', 'noopener,noreferrer');
};
